import { useEffect, useState } from "react";
import Field from "./Field";

export default function NumField({ label, value, min, max, onCommit, testId }) {
  const [text, setText] = useState(String(value));
  useEffect(() => setText(String(value)), [value]);
  const change = (v) => {
    const clean = v.replace(/\D/g, "").slice(0, 6);
    setText(clean);
    if (clean !== "") onCommit(Math.min(max, Math.max(min, parseInt(clean, 10))));
  };
  return (
    <div onBlur={() => text === "" && setText(String(value))}>
      <Field label={label} value={text} onChange={change} testId={testId} big />
    </div>
  );
}
